import { render } from "./PasswordEdit.vue?vue&type=template&id=3af08c2f&scoped=true"
import script from "./PasswordEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordEdit.vue?vue&type=script&setup=true&lang=js"

import "./PasswordEdit.vue?vue&type=style&index=0&id=3af08c2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af08c2f"],['__file',"src/views/password/PasswordEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3af08c2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3af08c2f', __exports__)) {
    api.reload('3af08c2f', __exports__)
  }
  
  module.hot.accept("./PasswordEdit.vue?vue&type=template&id=3af08c2f&scoped=true", () => {
    api.rerender('3af08c2f', render)
  })

}


export default __exports__